<div class="es-batch-review-header">
  <div class="es-batch-review-header-text">
    <div class="es-batch-review-header-text-ref-number">{{ referenceNumber }}</div>

    <div class="es-batch-review-header-text-checkbox">
      <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" id="es-batch-item-review" [formControl]="isConfirmedFc" />
        <label class="custom-control-label" for="es-batch-item-review">
          <span>{{ "BUTTON.CONFIRM" | translate }}</span>
        </label>
      </div>
    </div>
  </div>
  <div class="es-batch-review-header-close" (click)="closeSidebar()">×</div>
</div>

<ng-container *ngIf="!isLoading && !!entrySummary">
  <es-summary [isSidebar]="true"></es-summary>
</ng-container>

<loading-spinner [show]="isLoading"></loading-spinner>
